import { AppRoute as Route } from "./config";
import { useEffect, useState } from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Init as initializeAnalytics } from "./analytics";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import MainLayout from "./pages/layouts/Main";
import HomePage from "./pages/Home";
import TourPage from "./pages/Tour";
import PoiPage from "./pages/Poi";
import BlankPage from "./pages/Blank";
import { AppContentStatus } from "./config/AppContentStatus";

function App() {
  const { t } = useTranslation();
  const [contentStatus, setContentStatus] = useState(AppContentStatus.NewContentInstalled);

  useEffect(() => {
    serviceWorkerRegistration.register({
      onUpdateFound: onServiceWorkerUpdateFound,
      onUpdateFinished: onServiceWorkerUpdateFinished,
      onRegisterError: onServiceWorkerRegisterError,
    });
    initializeAnalytics();
  }, [])

  const onServiceWorkerUpdateFound = (registration) => {
    setContentStatus(AppContentStatus.NewContentAvailable);
  };

  const onServiceWorkerUpdateFinished = (registration) => {
    setContentStatus(AppContentStatus.NewContentInstalled);
  };

  const onServiceWorkerRegisterError = (error) => {
    setContentStatus(AppContentStatus.Error);
  };

  const closeContentStatusNotificationHandler = () => {
    setContentStatus(AppContentStatus.None);
  }

  const router = createBrowserRouter([
    { 
      path: Route.Home, 
      element: <MainLayout contentStatus={contentStatus} resetContentStatus={closeContentStatusNotificationHandler} />,
      children: [
        { index: true, element: <HomePage/> },
        { path: Route.Tour, element: <TourPage/> },
        { path: Route.Poi, element: <PoiPage/> },
        { 
          path: Route.Credits, 
          element: 
            <BlankPage 
              metaTitle={t("credits.meta.title")}
              metaDescription={t("credits.meta.description")}
              title={t("credits.title")}
              content={t("credits.content")}
            /> 
        }
      ],
      errorElement:
        <BlankPage 
          metaTitle={t("error.meta.title")}
          metaDescription={t("error.meta.description")}
          title={t("error.title")}
          content={t("error.content")}
        />
    },
  ]);

  return <RouterProvider router={router} />;
}

export default App;
